module.exports = __webpack_public_path__ + "static/media/expressjs.c6bab64b.svg";